import { useMutation, useQuery } from "@tanstack/react-query";
import { IActionResponse, IActionResult } from "../../../../assets/utils/lib";

import { Constants } from "../../../../assets/utils/lib/constants";
import { LookupDto } from "../../../../assets/utils/lib/lookupDto";
import { OrganizationDto } from "../../../../services/dto/communityResource/organizationDto";
import { CommunityOrganizationClient } from "../../../../services/proxies/community/communityOrganizationClient";
import { SearchOrganizationDto } from "./organizationPage";

export namespace ResourceOrganizationService {
    const resourceOrganizationClient = new CommunityOrganizationClient();

    export const save = () =>
        useMutation<IActionResult<OrganizationDto>, Error, OrganizationDto>({
            mutationFn: async (payload: OrganizationDto) => {
                return await resourceOrganizationClient.saveCommunityOrganizationAsync(
                    payload
                );
            },
        });

    export const getResourceOrganizationQuery = (id: string | undefined) =>
        useQuery({
            queryKey: ["resourceOrganizationQuery", id],
            queryFn: async () =>
                await resourceOrganizationClient.getCommunityOrganizationAsync(id),
            enabled: Boolean(id && id !== Constants.emptyGuid),
        });

    export const gridQuery = (searchQuery: SearchOrganizationDto) =>
        useQuery({
            queryKey: ["resourceOrganizationGridQuery", searchQuery],
            queryFn: async () =>
                await resourceOrganizationClient.searchCommunityOrganizationsAsync(
                    searchQuery
                ),
            enabled: Boolean(
                searchQuery.communityId && searchQuery.communityId !== Constants.emptyGuid
            ),
            placeholderData: (previousData) => previousData,
        });

    export const getLookups = (communityId: string | undefined) =>
        useQuery({
            queryKey: ["resourceOrganizationLookupsQuery", communityId],
            queryFn: async () => await resourceOrganizationClient.getLookupsAsync(communityId),
            enabled: Boolean(communityId && communityId !== Constants.emptyGuid),
            placeholderData: (previousData) => previousData,
            select: (data) => {
                return {
                    communities: LookupDto.mapToOptions(data?.community),
                    state: data?.state,
                    county: data?.county,
                    category: LookupDto.mapToOptions(data?.category),
                };
            },
        });

    export const deleteOrganization = () =>
        useMutation<IActionResponse, Error, string>({
            mutationFn: async (id: string | undefined) => {
                return await resourceOrganizationClient.deleteOrganizationAsync(id);
            },
        });

    export const deActivateOrganization = () =>
        useMutation<IActionResponse, Error, string>({
            mutationFn: async (organizationId: string | undefined) =>
                await resourceOrganizationClient.deActivateCommunityOrganizationAsync(
                    organizationId
                ),
        });
}